import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from './../Glob';
import BaseStore from '../../../../_common/platform/ts/BaseStore';
import { apiCall } from '../../../../_common/platform/ts/AqlUtility';
import { Constants } from '../../../../_common/platform/ts/Constants';
import { getCurrentUserId } from '../../../../_common/platform/ts/getCurrentUserId';

import { AppDispatcher as Dispatcher } from '../dispatcher/AppDispatcher';
import { Action, AppActions, I, check as checkAction } from '../actions/AppActions';

export interface IPermission {
    description: string;
    id: number;
}

export interface IUserOrGroup {
    name: string;
    userid: number;
    type: string;
}

export interface IUserPermissionDescription {
    label: string;
    name: string;
    permissionID: number;
}

export interface IPermissionsState {
    initialLoading: boolean;
    dirLoading: boolean;
    invalidPermission: boolean;

    permissions: IPermission[];
    usersOrGroups: { [index: number]: IUserOrGroup };

    dirPermissions: { [index: number]: any };

    displayDir?: number;
    displayName?: string;

    userPermissionsDescriptionLoading: boolean;
    userPermissionsDescription: IUserPermissionDescription[];
    userPermissionsDescriptionNameMap: { [name: string]: any };
    userPermissionsDescriptionIdMap: { [id: number]: any };

    userPermissions: { [id: number]: any };
    userPermissionsLoading: { [id: number]: boolean };
}

export class PermissionsStore extends BaseStore<IPermissionsState, AppActions, Dispatcher, IGlob> {
    public _state: IPermissionsState;
    public static _name = 'permissions';

    public static getInitialState() {
        return {
            initialLoading: false,
            dirLoading: false,
            invalidPermission: false,

            permissions: [],
            usersOrGroups: {},

            dirPermissions: {},

            displayDir: null,
            displayName: null,

            userPermissionsDescriptionLoading: false,
            userPermissionsDescription: [],
            userPermissionsDescriptionNameMap: {},
            userPermissionsDescriptionIdMap: {},

            userPermissions: {},
            userPermissionsLoading: {}
        };
    }

    private _defs: any = {};
    private loadedInitial: boolean = false;

    private getPermissionNames() {
        return apiCall(this.actions, 'dir_GetPermissionNames', {});
    }

    private getUsersAndGroups() {
        return apiCall(this.actions, 'dir_GetUsersAndGroupsForAddPermissions', {});
    }

    public readSavedState() {
        return this._state;
    }

    private initialLoad() {
        if (this.loadedInitial === true || this._state.initialLoading === true) {
            return;
        }

        var def = $.Deferred();
        var defs = [this.getPermissionNames(), this.getUsersAndGroups()];

        this._state.initialLoading = true;
        this._state.invalidPermission = false;

        $.when
            .apply($, defs)
            .then((permissionsResp: any, usersAndGroupsResp: any) => {
                def.resolve(permissionsResp.result, usersAndGroupsResp.result);
            })
            .fail((obj) => {
                def.reject(obj);
            });

        def.done((permissions: IPermission[], usersAndGroups: IUserOrGroup[]) => {
            this.setPermissions(permissions);
            this.setUsersAndGroups(usersAndGroups);

            this.actions.permissionsInitialDataLoadFinish(true);
        }).fail((obj: any) => {
            this.setPermissions([]);
            this.setUsersAndGroups([]);

            this.actions.showNotification_Fail(obj.error && obj.error.message);

            this.actions.permissionsInitialDataLoadFinish(false);
        });
    }

    private setPermissions(arr: IPermission[]) {
        this._state.permissions = arr;
    }

    private setUsersAndGroups(arr: IUserOrGroup[]) {
        _.each(arr, (obj) => {
            if (obj.userid >= 0) {
                obj.type = 'user';
            } else {
                obj.type = 'group';
            }
        });

        this._state.usersOrGroups = _.indexBy(arr, 'userid');
    }

    private initialLoadFinish(success: boolean) {
        if (success === true) {
            this.loadedInitial = true;
        }

        this._state.initialLoading = false;
    }

    private loadDir(dirid: number, name: string) {
        this._state.invalidPermission = false;
        var def = $.Deferred<any>();

        if (this._defs.loadDir != null && this._defs.loadDir.state() === 'pending') {
            this._defs.loadDir.resolve(null);
        }

        this._defs.loadDir = def;
        this._state.dirLoading = true;

        apiCall(
            this.actions,
            'dir_GetDirPermissions',
            {
                dirid: dirid
            },
            null,
            def
        );

        def.done((resp) => {
            var result = resp.result;

            // VR: never occurs: (because it converted to FAIL in apiCall):
            // if (result != null && result['code'] != undefined && result['message'] != undefined) { //ryb
            //
            //     this.actions.notification(
            //         'fail',
            //         result['message']
            //     );
            //
            //     this.actions.permissionsLoadDirFinish(false);
            //     return;
            // }

            this._state.dirPermissions[dirid] = result;
            this._state.displayDir = dirid;
            this._state.displayName = name;

            this.actions.permissionsLoadDirFinish(true);
        }).fail((obj) => {
            this.actions.permissionsLoadDirFinish(false);
        });
    }

    private loadDirFinish(success: boolean) {
        this._state.dirLoading = false;
        this._state.invalidPermission = !success;
    }

    private dirShow(dirid: number, name: string) {
        this.initialLoad();
        this.loadDir(dirid, name);
    }

    private dirHide() {
        this._state.displayDir = null;
        this._state.displayName = null;
    }

    private dirSave(dirid, name, permissions) {
        this.callBackend('dir_SetDirPermissions', {
            dirid: dirid,
            permissions: permissions
        }).done(() => {
            this.actions.permissionsDirHide();
            this.actions.showNotification_Success("Permissions were saved for folder '" + name + "'");
        });
    }

    private userPermissionsDescriptionDef;
    private userPermissionsLoadingDefs = {};

    private callBackend(method: string, params: any = {}): JQueryPromise<any> {
        return apiCall(this.actions, method, params);
    }

    public loadUserPermissionsDescription() {
        if (this._state.userPermissionsDescriptionLoading) {
            return this.userPermissionsDescriptionDef;
        }

        this._state.userPermissionsDescriptionLoading = true;

        return (this.userPermissionsDescriptionDef = this.callBackend('permission_GetDefinitions')
            .done(({ result: { definitions } }) => {
                this._state.userPermissionsDescription = definitions;
                this._state.userPermissionsDescriptionNameMap = _.indexBy(definitions, 'name');
                this._state.userPermissionsDescriptionIdMap = _.indexBy(definitions, 'permissionID');
            })
            .always(() => {
                delete this.userPermissionsDescriptionDef;
                this._state.userPermissionsDescriptionLoading = false;
                this.emitChange();
            }));
    }

    public loadUserPermissions(user: number = getCurrentUserId()) {
        if (this._state.userPermissionsLoading[user]) {
            return this.userPermissionsLoadingDefs[user];
        }

        this._state.userPermissionsLoading[user] = true;

        return (this.userPermissionsLoadingDefs[user] = apiCall<any>(this.actions, 'permission_GetUserPermissions', {
            userID: user
        })
            .done(({ result: { permissionIDList } }) => {
                this._state.userPermissions[user] = _.indexBy(permissionIDList, null);
            })
            .always(() => {
                delete this.userPermissionsDescriptionDef;
                delete this.userPermissionsLoadingDefs[user];
                this._state.userPermissionsLoading[user] = false;

                this.emitChange();
            }));
    }

    public checkPermission(user: number = getCurrentUserId(), permissionName?: string, permissionId?: number) {
        var permissionObj;

        if (permissionId != null && this._state.userPermissionsDescriptionIdMap[permissionId] == null) {
            if (window['jestTestRunTime_Mode'] == null) {
                console.log(`Permission with id ${permissionId} cannot be found`);
            }
            return null;
        }

        if (permissionId == null) {
            permissionObj = this._state.userPermissionsDescriptionNameMap[permissionName];
            permissionId = permissionObj && permissionObj.permissionID;
        }

        if (permissionObj == null) {
            if (window['jestTestRunTime_Mode'] == null) {
                console.log(`Permission with name ${permissionName} cannot be found`);
            }
            return null;
        }

        var userPermissions = this._state.userPermissions[user];

        if (userPermissions == null) {
            console.log(`Permissions are not loaded for user ${user}`);
            return null;
        }

        return userPermissions[permissionId] != null;
    }

    protected eventsHandler(payload) {
        if (!super.eventsHandler(payload)) {
            return false;
        }

        const a: any = payload.action;
        const _case = checkAction;

        do {
            if (_case<I.PERMISSIONS_INITIAL_DATA_LOAD>(a, Constants.PERMISSIONS_INITIAL_DATA_LOAD)) {
                this.initialLoad();

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_INITIAL_DATA_LOAD_FINISH>(a, Constants.PERMISSIONS_INITIAL_DATA_LOAD_FINISH)) {
                this.initialLoadFinish(a.success);

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_LOAD_DIR>(a, Constants.PERMISSIONS_LOAD_DIR)) {
                this.loadDir(a.dirid, a.name);

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_LOAD_DIR_FINISH>(a, Constants.PERMISSIONS_LOAD_DIR_FINISH)) {
                this.loadDirFinish(a.success);

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_DIR_SHOW>(a, Constants.PERMISSIONS_DIR_SHOW)) {
                this.dirShow(a.dirid, a.name);

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_DIR_HIDE>(a, Constants.PERMISSIONS_DIR_HIDE)) {
                this.dirHide();

                this.emitChange();
                break;
            }

            if (_case<I.PERMISSIONS_DIR_SAVE>(a, Constants.PERMISSIONS_DIR_SAVE)) {
                this.dirSave(a.dirid, a.name, a.permissions);

                this.emitChange();
                break;
            }

            if (_case<I.USER_PERMISSIONS_LOAD_DESCRIPTION>(a, Constants.USER_PERMISSIONS_LOAD_DESCRIPTION)) {
                this.loadUserPermissionsDescription();

                this.emitChange();
                break;
            }

            if (_case<I.USER_PERMISSIONS_LOAD_USER>(a, Constants.USER_PERMISSIONS_LOAD_USER)) {
                this.loadUserPermissions(a.user);

                this.emitChange();
                break;
            }

            if (_case<I.USERS_GROUPS_DATA_UPDATED>(a, Constants.USERS_GROUPS_DATA_UPDATED)) {
                this.loadedInitial = false;

                this.emitChange();
                break;
            }
        } while (false);

        return true;
    }

    constructor(glob, dispatcher: Dispatcher, actions: AppActions) {
        super(glob, dispatcher, actions, PermissionsStore._name);

        this._state = _.extend(PermissionsStore.getInitialState(), this._state);
    }

    static get(glob, dispatcher: Dispatcher, actions: AppActions) {
        return new PermissionsStore(glob, dispatcher, actions);
    }
}
